import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

export function authRoute(isAuthenticated, element) {
  return isAuthenticated ? element : <Navigate to="/login" />;
}

/**
 * 路由页懒加载工厂（React.lazy）
 *
 * 分包命名规范（配合 vite.config.js manualChunks，便于线上排查）：
 * - chunk-production：生产/农场/农事/驾驶舱等 pages/production、cockpit、growth-model
 * - chunk-mall：商城与个人中心相关 pages/mall、Profile、work-tasks
 * - chunk-core：农情资讯、气象农艺、知识库等核心次要页
 * - chunk-system：系统管理、权限、租户等
 * - chunk-stats：统计类页面（挂在 system/production 路径下的 statistics）
 * - vendor-echarts / vendor-dayjs：公共第三方库独立 chunk
 *
 * 用法：const XxxPage = lazyPage(() => import('../pages/...'));
 */
export function lazyPage(importer) {
  return lazy(importer);
}
